
export class PerfilMapa {

  private constructor(readonly roleId: string) {}

  static readonly DIRIGENTE = new PerfilMapa('P335S1')

}
